import React from "react";
import { IoRadioButtonOffSharp, IoRadioButtonOn } from "react-icons/io5";
import VisDiv from "../../../whitaijiFrontendLibrary/components/VisDiv";
import BlueButton from "../../BlueButton";

export const RadioButton = ({children, data}) => {

    const { answerId, userResponse, answerText, setUserResponse, question, doc, setDoc } = data
    const questionId = question?.questionId
    const updateDoc = (doc={}, newAnswerDoc={}) => {
        const existingAnswers = !doc?.userResponses ? [] : doc?.userResponses
/*         if(!doc) {
            process.env.NODE_ENV === "development" && console.log("doc does not exist", doc)
            return ({userResponses:[newAnswerDoc]})} */
        const newDoc = {...doc, userResponses:[...existingAnswers?.filter((x)=>x?.questionId !== newAnswerDoc?.questionId), newAnswerDoc]}
        //process.env.NODE_ENV === "development" && console.log("existingAnswers", existingAnswers, newDoc)
        return newDoc
    }
    const answerFn = () => {
        const newAnswerDoc = {questionId, answers:[{answerText, answerId}]}
        //process.env.NODE_ENV === "development" && console.log("userResponse", newAnswerDoc, question)
        setUserResponse({answers: [{answerText, answerId}], questionId})
        setDoc(updateDoc(doc, newAnswerDoc))
      
    }

    const testFunction = (e) => {
        e.stopPropagation()
        process.env.NODE_ENV === "development" && console.log("wkemelkwmxc", "userResponse", userResponse, "answerId", answerId, "questionId", questionId)
    }
    return (
        <div onClick={answerFn} className="radio-button-container">
            <VisDiv >
                <VisDiv className="flex-center" rules={[!userResponse?.answers?.some((x)=>x?.answerId === answerId)]}>
                    <IoRadioButtonOffSharp size={24} />
                </VisDiv>  
                <VisDiv className="flex-center"rules={[userResponse?.answers?.some((x)=>x?.answerId === answerId)]}>
                    <IoRadioButtonOn size={24} />
                </VisDiv>  
            </VisDiv>
            <div className="margin-left flex-center">
                <p>{children}</p>
            </div>
            <div className="margin-left flex-center">
                <BlueButton hide={true} margins={false} fn = {testFunction}/>
            </div>
          
        </div>
    );
}   